"use client";

import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { RefreshCcw, CheckCircle } from "lucide-react";
import { FilterControls } from "./FilterControls";
import { FilterItem } from "@/interfaces";

type FilterSheetProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filters: FilterItem[];
  onReset: () => void;
  onApply?: () => void;
  onClearFilter?: (index: number) => void;
};

/**
 * Sheet component for displaying filters on small screens (xs, sm, md)
 */
export const FilterSheet = ({ open, onOpenChange, filters, onReset, onApply, onClearFilter }: FilterSheetProps) => {
  const handleReset = () => {
    onReset();
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <SheetTitle>Filters</SheetTitle>
          <SheetDescription>Apply filters to refine your search results</SheetDescription>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto py-4 container px-4">
          <FilterControls 
            filters={filters} 
            containerClassName="pb-6" 
            itemClassName="grid-cols-1" 
            showActions={false}
            onClearFilter={onClearFilter}
          />
        </div>

        <SheetFooter className="flex-col sm:flex-row gap-2 mt-auto">
          <Button variant="secondary" onClick={handleReset} className="w-full sm:w-auto uppercase">
            <RefreshCcw className="w-4 h-4 mr-2" />
            Reset
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};
